import * as React from 'react';
import Skeleton from 'react-loading-skeleton';
import { displayIf, displayEither } from './utils';

export const renderLoadedText = (value, isLoading, lines = 1, width = 50, callback?) => {
  const computedValue = callback ? displayIf(callback(value), 'Unknown', value) : displayEither(value, 'Unknown');
  return isLoading ? computedValue : <Skeleton count={lines} width={`${width}%`}/>
}


// WEBPACK FOOTER //
// ./src/share/utils/placeholders.tsx